import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { FullScreenLoader } from '@/components/feedback/FullScreenLoader'
import { OrganizationSuspendedPage } from '@/features/auth/pages/OrganizationSuspendedPage'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { paths } from '@/routes/paths'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isBootstrapping, isOrganizationSuspended } = useAuth()
  const location = useLocation()

  if (isBootstrapping) {
    return <FullScreenLoader label="Verificando sesión..." />
  }

  // SA-5: distinto de "no autenticado" — el token sigue siendo válido,
  // por eso NO se redirige a /login. Nunca se aplica a un platform
  // operator (backend: get_current_active_user los exime por completo,
  // /auth/me nunca falla así para ellos — ver AuthProvider).
  if (isOrganizationSuspended) {
    return <OrganizationSuspendedPage />
  }

  if (!isAuthenticated) {
    return <Navigate to={paths.login} replace state={{ from: location }} />
  }

  return children
}
